import { InstanceSerializer, StudioDataInstance } from '@gametailors/lp-studio-connector';
import { MockGenerators } from './recommendations-mock-generators';

export class CodeMockApi {
  /**
   * POST ...
   */
  public async saveHomeworkConfig(id: string, assignments: StudioDataInstance[]): Promise<void> {
    throw new Error('Not implemented');
  }

  /**
   * GET ...
   */
  public async getHomeworkConfig(id: string): Promise<StudioDataInstance[] | undefined> {
    const activities = [
      await MockGenerators.generateWisselklankenActivity(),
      await MockGenerators.generateWisselklankenActivity(),
      await MockGenerators.generateWoordpadActivity(),
      await MockGenerators.generateLettermixActivity(),
      await MockGenerators.generateZinlezenActivity('NORMAAL'),
      await MockGenerators.generateDicteeActivity('Digitaal'),
      await MockGenerators.generateLeeslijstActivity({ variant: 'CATEGORISE' }),
      await MockGenerators.generateLeeslijstActivity({ variant: 'STOPWATCH' }),
      await MockGenerators.generateLeeslijstActivity({ variant: 'STOPWATCH' }),
      await MockGenerators.generateLeeslijstActivity({ variant: 'TIMER', duration: 8 }),
    ];
    return new InstanceSerializer().serializeMany(activities);
  }
}
